export default {
  eventInProgress: (state) => {
    const { eventName } = state;
    const events = ['countdown', 'StartCountdown', 'bettingDisabled', 'StopBetting'];
    return eventName && events.indexOf(eventName) < 0;
  },
  keepValidInputOnBetChange: (state, getters) => getters.configFromStatic?.keepValidInputOnBetChange || false,
  isFutureBetActive: (state) => state.additionalInputs.filter((input) => input.betType === 'future')[0] ?? false,
  futureInput: (state) => state.additionalInputs.filter((input) => input.betType === 'future')[0] || {},
  futureValue: (state) => state.betInputData.future,
  isSystemBetActive: (state) => state.additionalInputs.filter((input) => input.betType === 'system')[0] ?? false,
  paytable: (state) => state.paytable,
};
